module.exports = __webpack_public_path__ + "img/page-21.b1214482.jpg";